import { render, staticRenderFns } from "./CheckoutSSRs.vue?vue&type=template&id=8fc18fd2&scoped=true"
import script from "./CheckoutSSRs.vue?vue&type=script&lang=js"
export * from "./CheckoutSSRs.vue?vue&type=script&lang=js"
import style0 from "./CheckoutSSRs.vue?vue&type=style&index=0&id=8fc18fd2&prod&lang=css"
import style1 from "./CheckoutSSRs.vue?vue&type=style&index=1&id=8fc18fd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc18fd2",
  null
  
)

export default component.exports